import { useEffect, useState, useRef } from "react";

interface UseCountingAnimationProps {
  end: number;
  duration?: number;
  isVisible: boolean;
  suffix?: string;
  prefix?: string;
}

export const useCountingAnimation = ({
  end,
  duration = 2000,
  isVisible,
  suffix = "",
  prefix = "",
}: UseCountingAnimationProps) => {
  const [count, setCount] = useState(0);
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (!isVisible || hasAnimated.current) return;
    
    hasAnimated.current = true;
    let startTime: number | null = null;
    const startValue = 0;

    const animate = (currentTime: number) => {
      if (startTime === null) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      
      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentCount = Math.floor(easeOutQuart * (end - startValue) + startValue);
      
      setCount(currentCount);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    requestAnimationFrame(animate);
  }, [end, duration, isVisible]);

  return `${prefix}${count.toLocaleString()}${suffix}`;
};
